import styled from 'styled-components/macro';
import * as colors from '../../../../../common/colorConstants';

export const ResultsTable = styled.table`
  margin-bottom: 0 !important;
`;

export const TableBody = styled.tbody`
  overflow-y: scroll;
  height: ${(props) => props.currentHeight - 430 - props.searchBarHeight}px;
  display: block;
  ::-webkit-scrollbar {
    width: 10px;
    z-index: 5;
  }
  ::-webkit-scrollbar-track {
    background-color: light-gray;
    border-radius: 10px;
    z-index: 5;
  }
  ::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: 10px;
    z-index: 5;
  }
  @media (max-height: 650px) {
    height: ${(props) => props.currentHeight - 360 - props.searchBarHeight}px;
  }
`;

export const ExtraRow = styled.tr`
  height: 90px;
`;

export const LabelRow = styled.tr`
  display: flex;
`;

export const SearchSectionLabel = styled.td`
  background-color: ${colors.darkWhite1};
  padding: 5px 20px;
  width: 100%;
`;

export const ResultsCancelSubscriptionBox = styled.div`
  padding: 0px 25px 25px 25px;
  text-align: left;
  & table {
    table-layout: fixed;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  @media (max-width: 1500px) {
    padding: 0px 25px;
  }
`;
